/**
 * Slice 45 — Attention banner for leave-out / past-counts forecast.
 */
import { cn } from "@/lib/utils";
import { useSupplyForecast } from "@/hooks/useSupplyForecast";
import { formatBannerLine } from "@/lib/supplyForecast";

interface InventoryPredictionBannerProps {
  propertyId: string;
  onOrderAndTrack?: (item: { item_id: string; item_name: string; quantity: number }) => void;
}

export default function InventoryPredictionBanner({
  propertyId,
}: InventoryPredictionBannerProps) {
  const { attention, isLoading } = useSupplyForecast(propertyId);

  if (isLoading || attention.length === 0) return null;

  const top = attention.slice(0, 2);

  const scrollToTable = () => {
    document.getElementById("inventory-predictions")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className={cn(
        "rounded-[16px] border border-[#f3dcb0] border-l-4 border-l-[#e5a54b]",
        "bg-[#fff8e8] px-4 py-3.5",
      )}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-1.5">
          <div className="text-[13px] font-bold uppercase tracking-[0.4px] text-[#7a4505]">
            Supplies to order
          </div>
          {top.map((row) => (
            <div key={row.item_id} className="text-[15px] font-semibold text-[#6b4600]">
              {formatBannerLine(row)}
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={scrollToTable}
          className="shrink-0 text-[13.5px] font-bold text-[#7a4505] hover:underline"
        >
          See forecast
        </button>
      </div>
    </div>
  );
}
